(function ($, undefined) {
	'use strict';
	var toggleTriggerElement;
	var submitProgramFormBtn;
	var file;
	var fileInput;
	var numbersOnlyInput;
	var deleteCoachingProgramBtn;
	var changeCoachingStatusBtn;
	var toggleCoachsPopupBtn;
	var changeCoachBtn;

	var toggleElement = function (e) {
		var t = $(this);
		var parent = t.closest('.toggle-outer-ctn');
		var element = parent.children('.element-to-toggle');
		var delay = 0;

		if (t.hasClass('sliding')) {
			e.preventDefault();
		}

		t.addClass('sliding');

		if (element.hasClass('hide')) {
			element.slideDown(300, function () {
				if (t.hasClass('toggle-required')) {
					element.find('input.derequired').removeClass('derequired').addClass('required');
				}

				t.removeClass('sliding');
				$(this).removeClass('hide');
			});

		} else {
			element.slideUp(300, function () {
				if (t.hasClass('toggle-required')) {
					element.find('input.required').removeClass('required').addClass('derequired');
				}

				t.removeClass('sliding');
				$(this).addClass('hide');
			});
		}
	};

	var addCoach = function () {
		var t = $(this);
		var id = t.attr('data-id');
		var clone = $('.program-coach.clone').clone();
		var list = $('.coachs-list-input').val();

		$('.coachs-list-input').val(list + id + ',');

		clone.find('.coach-name').html(t.find('.coach-name').html());
		clone.find('.coach-availability').html(t.find('.coach-availability').html());
		clone.attr('data-id', id);

		$('.program-chosen-coach-list-inner').append(clone.removeClass('clone'));
		t.remove();
		
		$('table').trigger('update');
		$('.program-chosen-coach-list-ctn').slideDown();

		if ($('.list-coachs-to-choose-inner').children().length === 0) {
			$('.list-coachs-to-choose').slideUp();
			$('.add-coach-toggle-btn').slideUp();
		}
	};

	var removeCoach = function () {
		var t = $(this);
		var ctn = t.closest('.program-coach');
		var id = ctn.attr('data-id');
		var clone = $('.program-add-coach-btn.clone').clone();
		var list = $('.coachs-list-input').val();
		var newList = list.split(id + ',').join('');

		$('.coachs-list-input').val(newList);

		clone.find('.coach-name').html(ctn.find('.coach-name').html());
		clone.find('.coach-availability').html(ctn.find('.coach-availability').html());
		clone.attr('data-id', id);

		$('.list-coachs-to-choose-inner').append(clone.removeClass('clone'));
		ctn.remove();

		$('table').trigger('update');
		$('.add-coach-toggle-btn').slideDown();

		if ($('.program-chosen-coach-list-ctn tbody').find('.program-coach:not(.clone)').length === 0) {
			$('.program-chosen-coach-list-ctn').slideUp();
		}
	};

	var submitProgramForm = function () {
		var btn = $(this);
		var form = btn.closest('form');

		if (chkReqFields(form)) {
			btn.addClass('disabled');
			form.submit();
		}
	};

	var fileInputChange = function () {
		var t = $(this);
		var label = t.closest('.form-item-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-item-upload-input-label-value', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');
			labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);

		} else {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}
	};

	var typeNumbersOnly = function (event) {
		if (!event.shiftKey && (event.which === 0 || event.which === 8 || event.which === 48 || event.which === 49 || event.which === 50 || event.which === 51 || event.which === 52 || event.which === 53 || event.which === 54 || event.which === 55 || event.which === 56 || event.which === 57)) {
			return true;
		} else {
			event.preventDefault();
			return false;
		}
	};

	var deleteCoachingProgram = function () {
		var t = $(this);
		var id = t.attr('data-id');

		var url = '/action/shopDeleteProduct?ajax=true';
		url += '&productId=' + id;

		ajax(url, function (response) {
			t.closest('.stool-shared-popup').find('.stool-shared-popup-close-btn').trigger('click');
			if (response.indexOf('success') !== -1) {
				$('.coaching-one-program[data-id='+id+']').slideUp(function () {
					$(this).remove();
				});
			}
		}, true);
	};

	var changeCoachingStatus = function () {
		var t = $(this);
		var status = t.data('status');
		var textCtn = t.closest('td').find('.coaching-status-text');

		var url = '/action/pmiPayment?ajax=true';
		url += '&paymentDetailId=' + t.attr('data-id');
		url += '&status=' + status;

		ajax(url, function (response) {
			if (response.indexOf('success') !== -1) {
				t.data('status', !status);
				if (status) {
					textCtn.html(textCtn.attr('data-true'));
				} else {
					textCtn.html(textCtn.attr('data-false'));
				}
			}
		}, true);
	};

	var toggleCoachsPopup = function () {
		var t = $(this);
		var popup = t.closest('td').find('.coachs-popup-outer');

		popup.toggleClass('open');
	};

	var changeCoach = function () {
		var t = $(this);
		var coachNameText = t.closest('td').find('.coach-name');
		var popup = t.closest('.coachs-popup');
		var checked = popup.find('input.coach-id:checked');

		var url = '/action/pmiPayment?ajax=true';
		url += '&paymentDetailId=' + t.attr('data-id');
		url += '&coachId=' + checked.val();

		ajax(url, function (response) {
			if (response.indexOf('success') !== -1) {
				coachNameText.html(checked.closest('label').find('span:not(.form-check-input-check) p').html());
			}
			popup.find(toggleCoachsPopupBtn).trigger('click');
		}, true);
	};

	var updateFormHeader = function() {
		$('.coaching-program-form-header-program-name').html($(this).val());
	};

	var init = function (adminWrapper) {
		toggleTriggerElement = $('.toggle-trigger-element-admin', adminWrapper);
		submitProgramFormBtn = $('.submit-program-form-btn', adminWrapper);
		file = $('.form-item-upload', adminWrapper);
		fileInput = $('.form-item-upload-input', file);
		numbersOnlyInput = $('input.numbers-only', adminWrapper);
		deleteCoachingProgramBtn = $('.delete-coaching-program-btn', adminWrapper);
		changeCoachingStatusBtn = $('.change-coaching-status-btn', adminWrapper);
		toggleCoachsPopupBtn = $('.toggle-coach-popup-btn', adminWrapper);
		changeCoachBtn = $('.change-coach-btn', adminWrapper);


		toggleTriggerElement.click(toggleElement);
		$(adminWrapper).on('click', '.program-add-coach-btn', addCoach);
		$(adminWrapper).on('click', '.program-remove-coach', removeCoach);
		submitProgramFormBtn.click(submitProgramForm);
		fileInput.change(fileInputChange);
		numbersOnlyInput.keypress(typeNumbersOnly);
		deleteCoachingProgramBtn.click(deleteCoachingProgram);
		changeCoachingStatusBtn.click(changeCoachingStatus);
		toggleCoachsPopupBtn.click(toggleCoachsPopup);
		changeCoachBtn.click(changeCoach);
		$('.coaching-program-form-name-input').keyup(updateFormHeader);
	};

	$(function() {
		var adminWrapper = $('.admin-wrapper');

		if (adminWrapper.length) {
			init(adminWrapper);
		}
	});

})(jQuery);
